import React from 'react'
import { LangSteps32 } from '../../../constant/languange'
import Content from '../Content'

const Third2 = (props) => {
  const data = {
    title: '',
    steps: [LangSteps32],
    button: 'Mulai Tambah Karyawan',
    nextStep: 4,
    skipTo: '/personnel/work/time',
    isDone: props.stats.personnels_count
  }

  return <Content {...props} data={data} />
}

export default Third2
